import { render, staticRenderFns } from "./table-tertiary.vue?vue&type=template&id=6b871c32&scoped=true&"
import script from "./table-tertiary.vue?vue&type=script&lang=js&"
export * from "./table-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b871c32",
  null
  
)

export default component.exports